import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { Divider } from "@mui/material";
import BarcodeComponent from "./barcode/BarcodeComponent";
import Dropdown from "../../common/components/Dropdown";
import DropdownContent from "../../common/components/DropdownContent";
import OnboardingContent from "../../common/components/OnboardingContent";
import parse from "html-react-parser";
import { fromPublic, replaceGlobalConfigVars, wireCallbacks } from "../../utils";

const PageContainer = styled.div`
  background-color: #eef3f2;
  -webkit-overflow-scrolling: touch;
  z-index: 0;
`;

const GreenHeader = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 70vh;
  background-color: #0e893c;
  z-index: 1;
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
`;

const OnboardingImageContainer = styled.div`
  padding-top: 32px;
  padding-bottom: 0;
`;

const OnboardingImage = styled.img`
  width: 100%;
  height: auto;
`;

const BarcodeArea = styled.div`
  position: relative;
  z-index: 10;
  padding: 0px 16px;
  margin-bottom: -24px;
`;

const HelpArticleContainer = styled.div`
  position: relative;
  justify-content: center;
  flex-direction: column;
  padding: 18px;
  padding-top: 42px;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  background-color: #eef3f2;
  margin-top: -40px;
  overflow: hidden;
  flex: 1;
  min-height: 50vh;
  z-index: 2;

  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 16px;
    background-color: #eef3f2;
    border-top-left-radius: 16px;
    border-top-right-radius: 16px;
    z-index: 15;
    pointer-events: none;
  }
`;

const ContentSection = styled.div`
  margin-top: 24px;
  margin-bottom: 24px;
`;

const OnboardingScreen: React.FC = () => {
  const sevenElevenConfig = GLOBAL_CFG["7-eleven"];
  const onboardingCfg = sevenElevenConfig.onboarding1;

  useEffect(() => {
    try {
      wireCallbacks();
    } catch (err) {
      console.error("Failed to wire callbacks on onboarding screen:", err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderDropdowns = () => {
    if (!onboardingCfg.dropdowns?.length) return null;
    return (
      <div style={{ marginTop: "24px" }}>
        <Divider sx={{ marginTop: "16px" }} />
        <h2 style={{ marginTop: "24px" }}>{parse(replaceGlobalConfigVars(onboardingCfg.dropdownHeading ?? ""))}</h2>
        {(onboardingCfg.dropdowns ?? []).map((dropdown: any) => (
          <Dropdown
            key={dropdown.heading}
            items={[
              parse(replaceGlobalConfigVars(dropdown.heading)),
              <DropdownContent
                key={`${dropdown.heading}-content`}
                content={replaceGlobalConfigVars(dropdown.content)}
                iconUrl={onboardingCfg.pointIcon}
              />,
            ]}
          />
        ))}
      </div>
    );
  };

  return (
    <PageContainer>
      <GreenHeader />
      <ContentWrapper>
        <OnboardingImageContainer>
          <OnboardingImage src={fromPublic(onboardingCfg.image)} alt="Onboarding Header" />
        </OnboardingImageContainer>
        <BarcodeArea>
          <BarcodeComponent barcodeConfig={sevenElevenConfig.barcode} isActive={true} />
        </BarcodeArea>
        <HelpArticleContainer>
          <OnboardingContent iconUrl={onboardingCfg.pointIcon}>
            <ContentSection>{parse(replaceGlobalConfigVars(onboardingCfg.content))}</ContentSection>
            {renderDropdowns()}
          </OnboardingContent>
        </HelpArticleContainer>
      </ContentWrapper>
    </PageContainer>
  );
};

export default OnboardingScreen;
